import React, { useState, useEffect } from 'react'
import { Container, Card, Form } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-quill/dist/quill.snow.css'
import ReactQuill from 'react-quill'

const CourseMessages = ({
  courseName,
  studentEmail,
  isEnrolled,
  isCompleted,
}) => {
  const [welcomeMessage, setWelcomeMessage] = useState(
    'Welcome to our course! We are excited to have you.'
  )
  const [congratsMessage, setCongratsMessage] = useState(
    'Congratulations on completing the course! Keep learning.'
  )
  const token = localStorage.getItem('jwttoken')

  // Function to send Welcome Email
  const sendWelcomeEmail = async () => {
    if (!studentEmail || !courseName || !welcomeMessage) return

    try {
      const response = await fetch(
        'https://kaasbackend.vetrinahealthcare.com/lms/send-welcome-email/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            email: studentEmail,
            course_name: courseName,
            message: welcomeMessage,
          }),
        }
      )

      if (response.ok) {
        console.log('✅ Welcome email sent successfully!')
      } else {
        console.error('❌ Failed to send welcome email.')
      }
    } catch (error) {
      console.error('Error sending welcome email:', error)
    }
  }

  // Function to send Congratulations Email
  const sendCongratsEmail = async () => {
    if (!studentEmail || !courseName || !congratsMessage) return

    try {
      const response = await fetch(
        'https://kaasbackend.vetrinahealthcare.com/lms/send-congratulations-email/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            email: studentEmail,
            course_name: courseName,
            message: congratsMessage,
          }),
        }
      )

      if (response.ok) {
        console.log('✅ Congratulations email sent successfully!')
      } else {
        console.error('❌ Failed to send congratulations email.')
      }
    } catch (error) {
      console.error('Error sending congratulations email:', error)
    }
  }

  // Auto-send Welcome Email when student enrolls
  useEffect(() => {
    if (isEnrolled && studentEmail && courseName) {
      sendWelcomeEmail()
    }
  }, [isEnrolled, studentEmail, courseName])

  // Auto-send Congratulations Email when student completes the course
  useEffect(() => {
    if (isCompleted && studentEmail && courseName) {
      sendCongratsEmail()
    }
  }, [isCompleted, studentEmail, courseName])

  return (
    <Container className='mt-4'>
      <Card className='p-4 shadow-sm'>
        <h3 className='mb-3'>Course Messages</h3>
        <p>
          Write messages that will be sent automatically when students enroll or
          complete the course.
        </p>

        {/* Welcome Message Editor */}
        <Form.Group className='mb-4'>
          <Form.Label>
            <strong>Welcome Message</strong>
          </Form.Label>
          <ReactQuill
            value={welcomeMessage}
            onChange={setWelcomeMessage}
            className='custom-editor'
          />
        </Form.Group>

        {/* Congratulations Message Editor */}
        <Form.Group className='mb-4'>
          <Form.Label>
            <strong>Congratulations Message</strong>
          </Form.Label>
          <ReactQuill
            value={congratsMessage}
            onChange={setCongratsMessage}
            className='custom-editor'
          />
        </Form.Group>
      </Card>
    </Container>
  )
}

export default CourseMessages
